import { useState, useEffect } from 'react';

const useCounter = (end, duration = 2200, inView) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!inView) return;
        let startTime = null;
        const easeOut = t => 1 - Math.pow(1 - t, 4);

        const step = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const elapsed = timestamp - startTime;
            const progress = Math.min(elapsed / duration, 1);
            setCount(Math.floor(easeOut(progress) * end));
            if (progress < 1) requestAnimationFrame(step);
            else setCount(end);
        };

        requestAnimationFrame(step);
    }, [inView, end, duration]);

    return count;
};

export default useCounter;
